import {
  IX_SITE_ID,
  PUBMATIC_PUBLISHER_ID,
  RUBICON_ACCOUNT_ID,
  RUBICON_SITE_ID,
  RUBICON_ZONE_ID,
  UNDERDOG_SITE_ID,
  OPENX_UNIT_ID,
  OPENX_DOMAIN,
  adUnitAlias,
  adUnitAliasToPath,
  MEDIANET_CID,
  MEDIANET_CRID,
} from '../../constants'
import logBase from '../../utils/logger'

const log = logBase.extend('PREBID')

const getPartnersBids = (unitPath: adUnitAlias) => {
  return {
    partners: {
      ix: {
        params: {
          siteId: IX_SITE_ID[unitPath],
        },
      },
      pubmatic: {
        params: {
          publisherId: PUBMATIC_PUBLISHER_ID,
        },
      },
      rubicon: {
        params: {
          accountId: RUBICON_ACCOUNT_ID,
          siteId: RUBICON_SITE_ID,
          zoneId: RUBICON_ZONE_ID[unitPath],
          position: 'atf', // above the fold
        },
      },
      underdogmedia: {
        params: {
          siteId: UNDERDOG_SITE_ID[unitPath],
        },
      },
      openx: {
        params: {
          unit: OPENX_UNIT_ID[unitPath],
          delDomain: OPENX_DOMAIN,
        },
      },
      medianet: {
        params: {
          cid: MEDIANET_CID,
          crid: MEDIANET_CRID[unitPath],
        },
      },
    },
  }
}

// create partner data for ID5
export const getPDForID5 = () => {
  const fullURL: string = window.location.href
  const domain: string = window.location.hostname
  const userAgent: string = window.navigator.userAgent
  const pdKeys = {
    8: encodeURIComponent(fullURL),
    9: encodeURIComponent(domain),
    12: encodeURIComponent(userAgent),
  }

  // convert the key/values into a querystring format
  const pdRaw = Object.entries(pdKeys)
    .map((entry) => {
      return `${entry[0]}=${entry[1]}`
    })
    .join('&')

  // base64 encode the raw string; this is the final value you can pass into the pd field
  const pdString = window.btoa(pdRaw)
  return pdString
}

export const partnersConfig = {
  config: {
    userSync: {
      userIds: [
        {
          name: 'id5Id',
          params: {
            partner: 1470,
            pd: getPDForID5(),
          },
          storage: {
            type: 'html5', // "html5" is the required storage type
            name: 'id5id', // "id5id" is the required storage name
            expires: 90, // storage lasts for 90 days
            refreshInSeconds: 8 * 3600, // refresh ID every 8 hours to ensure it's fresh
          },
        },
      ],
      auctionDelay: 50,
      iframeEnabled: true,
      filterSettings: {
        iframe: {
          bidders: '*', // '*' represents all bidders
          filter: 'include',
        },
      },
    },
  },
  bidderSettings: {
    ix: {
      storageAllowed: true,
    },
  },
}

export const buildPrebidPartnersBids = (unitPath: adUnitAlias) => {
  log('Building partners config...')

  if (!Object.values(adUnitAliasToPath).includes(unitPath)) {
    throw new Error(`Invalid unit path ID: ${unitPath}`)
  }

  const bids = []
  const { partners } = getPartnersBids(unitPath)

  for (const [partner, { params }] of Object.entries(partners)) {
    bids.push({
      bidder: partner,
      params,
    })
  }

  return { bids }
}
